
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HinaCheckbox from "@/views/ai-builder-component/baseComponent/hina-checkbox.vue";

@Component({
  components: { HinaCheckbox }
})
export default class HinaRadioGroup extends Vue {
  @Prop() value!: any;
  @Prop({ default: () => [] }) options!: {
    name: string;
    value: any;
    class?: string;
    disabled?: boolean;
  }[];

  v = this.value;

  @Watch("value", { immediate: true })
  handleValueChange() {
    this.v = this.value;
  }

  handleChange() {
    this.$emit("update:value", this.v);
    this.$emit("change", this.v);
  }
}
